import React, { useContext, useEffect, useState } from 'react'
import { AuthContext, EventsContext, LanguageContext, NotificationContext } from '../context'
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl'; // Added Import
import PhoneCustomInput from './UI/PhoneInput';


function PassengerModal({ showModal, onClose, waitlist, vehicle, onConfirm, passenger, onRemove, event }) {

  const { userData, promptAuth, isUserAuthenticated } = useContext(AuthContext)
  const { toast } = useContext(NotificationContext)
  const { t } = useContext(LanguageContext)

  const availableSeatsForTrip = (journeyType) => {
    if (!vehicle) return 0
    if (!vehicle[journeyType]) return 0
    if (!vehicle[journeyType].available) return 0
    if (!vehicle[journeyType].available_seats) return 0
    return vehicle[journeyType].available_seats - (vehicle.passengers || []).filter(p => p[journeyType]).length
  }

  const vehicleAvailableSeats = { trip1: availableSeatsForTrip("trip1"), trip2: availableSeatsForTrip("trip2") }

  const [passengerOption, setPassengerOption] = useState('')
  const [passengerOptions, setPassengerOptions] = useState([
    // not including user as passenger option - https://trello.com/c/MGelwZs9/12-passenger
    // {
    //   firstname: '',
    //   trip1: waitlist || vehicleAvailableSeats.trip1 > 0,
    //   trip2: waitlist || vehicleAvailableSeats.trip2 > 0,
    //   isUser: true
    // },
  ])

  const [passengerData, setPassengerData] = useState({
    firstname: '',
    lastname: '',
    phone: '',
    email: '',
    passengers: [{
      firstname: '',
    }],

  })

  const [loading, setLoading] = useState(false)

  const [formSubmitted, setFormSubmitted] = useState(false)

  const handleAddPassengerOption = () => {
    const newOption = passengerOption.trim()
    if (!newOption) {
      toast({ message: t('passenger.enter_name_error'), variant: 'warning' })
      return
    }
    setPassengerOptions([...passengerOptions, {
      firstname: passengerOption,
      trip1: waitlist || vehicleAvailableSeats.trip1 > passengerOptions.filter(p => p.trip1).length,
      trip2: waitlist || vehicleAvailableSeats.trip2 > passengerOptions.filter(p => p.trip2).length
    }])
    setPassengerOption('')
  }

  const handleTogglePassengerOption = (index, trip) => () => {
    if (index === -1) {
      // toggle all
      setPassengerOptions(current => {
        let isAll = current.every(option => option[trip])
        return current.map(option => ({ ...option, [trip]: !isAll }))
      })
      return
    }
    setPassengerOptions(current => {
      const updated = [...current]
      updated[index] = {
        ...updated[index],
        [trip]: !updated[index][trip]
      }
      return updated
    })
  }

  useEffect(() => {
    const updates = {}
    updates.firstname = passenger?.firstname || userData?.firstname || ''
    updates.lastname = passenger?.lastname || userData?.lastname || ''
    updates.phone = passenger?.phone || userData?.phone || ''
    updates.email = passenger?.email || userData?.email || ''
    let passOptions = []
    if (passenger?.passengers) {
      passOptions = passenger.passengers.map(p => ({
        firstname: p.firstname,
        trip1: p.trip1 || false,
        trip2: p.trip2 || false,
      }))
    }


    if (userData?.children) {
      userData.children.forEach((child, index) => {
        if (passOptions.find(p => p.firstname === child.firstname)) return
        passOptions.push({
          firstname: child.firstname,
          trip1: passenger ? false : (waitlist || vehicleAvailableSeats.trip1 >= index + 1),
          trip2: passenger ? false : (waitlist || vehicleAvailableSeats.trip2 >= index + 1)
        })
      })
    }
    if (event?.waitlist) {
      event.waitlist.filter(child => child.user_id === userData.id).forEach((child, index) => {
        if (passOptions.find(p => p.firstname === child.firstname)) return
        passOptions.push({
          firstname: child.firstname,
          trip1: passenger ? false : (waitlist || vehicleAvailableSeats.trip1 >= index + 1) && child.trip1,
          trip2: passenger ? false : (waitlist || vehicleAvailableSeats.trip2 >= index + 1) && child.trip2
        })
      })
    }
    setPassengerOptions(passOptions)
    if (Object.keys(updates).length > 0) {
      setPassengerData({ ...passengerData, ...updates })
    }
  }, [userData, vehicle, passenger, event])

  const handleChange = (key) => (e) => {
    const keyComponents = key.split('.')
    if (keyComponents.length > 1) {
      setPassengerData({
        ...passengerData, [keyComponents[0]]: passengerData[keyComponents[0]].map((child, index) => {
          if (index === parseInt(keyComponents[1])) {
            return { ...child, [keyComponents[2]]: e.target.value }
          }
          return child
        })
      })
    } else {
      setPassengerData({ ...passengerData, [key]: e.target.value })
    }
  }


  const handleInputChange = (e, index) => {
    setPassengerOptions(current => {
      const updated = [...current];
      updated[index] = {
        ...updated[index],
        firstname: e
      };
      return updated;
    });
  }

  useEffect(() => {
    if (passengerOptions[passengerOptions.length - 1]?.firstname !== '') {
      setPassengerOptions(current => {
        const updated = [...current, {
          firstname: '',
          trip1: false,
          trip2: false
        }];
        return updated;
      });
    }
  }, [passengerOptions])


  const handlePhoneChange = (e) => {
    setPassengerData({ ...passengerData, phone: e })
  }

  const handleSubmit = async () => {
    setFormSubmitted(true)
    if (!passengerData.firstname || !passengerData.lastname || !passengerData.phone || !passengerData.email) {
      toast({ message: t('generic.complete_all_fields'), variant: 'error' })
      return
    }
    const validPassengers = passengerOptions.filter(p => p.firstname && (p.trip1 || p.trip2)).map(p => ({ firstname: p.isUser ? passengerData.firstname : p.firstname, trip1: p.trip1, trip2: p.trip2 }))
    if (validPassengers.length === 0 && !passenger) { // at least one passenger should be selected when first joining vehicle or waitlist
      toast({ message: t('passenger.select_one'), variant: 'error' })
      return
    } else if (validPassengers.length === 0) { // if no passenger is selected, remove passenger from vehicle
      return handleRemove()
    }
    setLoading(true)
    const response = await onConfirm({
      ...passengerData,
      passengers: validPassengers
    })
    setLoading(false)
    if (response) {
      onClose()
      setFormSubmitted(false)
      toast({ message: t('generic.changes_saved'), variant: 'success' })
    }
  }

  const handleRemove = async () => {
    setLoading(true)
    const response = await onRemove(passengerData.id)
    setLoading(false)
    if (response) {
      onClose()
    }
  }

  const isPassengerCheckboxDisabled = (trip, seatIndex) => {
    if (waitlist) return false
    if (!vehicle) return true
    if (!vehicle[trip]) return true
    if (!vehicle[trip].available) return true
    if (!vehicle[trip].available_seats) return true
    if (seatIndex === -1) {
      return passengerOptions.length > vehicle[trip].available_seats
    }
    if (!passengerOptions[seatIndex][trip] && passengerOptions.filter(p => p[trip]).length >= vehicle[trip].available_seats) return true
  }

  return (
    <div className={`w-full ${showModal ? '' : 'hidden'}`}>
      <div
        className="justify-center items-center z-50 rounded-lg modal-container ">
        <div className="flex items-start justify-between pt-16 pb-9 px-5  ">
          <h3 className="modal-title">
            {waitlist ? passenger ? t('passenger.waitlist_modify') : t('passenger.waitlist_join') : t('passenger.details_title')}
          </h3>
          <button
            className="p-1 bg-transparent text-black text-3xl absolute top-2 right-4"
            onClick={onClose}
          >
            ×
          </button>
        </div>
        <div className="modal-box ">
          <div>
            <div className=''>
              {!isUserAuthenticated && (
                <label className='block mb-6'>
                  {t('modal.login_label')}&nbsp;<span className='link' onClick={() => promptAuth()}><b>{t('modal.login_link')}</b></span>
                </label>
              )}

              <FormControl fullWidth>
                <label className='block mb-4 font-semibold'>
                  {t('passenger.passengers_title')}
                </label>
                {/* <div className='gap-4 mb-6'>
                  <label className='block mb-2'>
                    {t('passenger.add_passenger_title')}
                  </label>
                  <div className='flex gap-4 items-center'>
                    <input type='text' className='' value={passengerOption} onChange={(e) => setPassengerOption(e.target.value)} />
                    <button className='h-[60px] rounded-lg light' onClick={handleAddPassengerOption}>
                      {t('generic.confirm')}
                    </button>
                  </div>
                </div> */}
                <div className='w-full mb-6'>
                  {passengerOptions.map((option, index) => (
                    <div key={index} className='flex mb-3'>
                      <div className='flex flex-col gap-2'>
                        {index === 0 && <label className='block text-left'>
                          {t('generic.firstname')}
                        </label>}
                        <input type='text' className='' value={option.firstname} onChange={(e) => handleInputChange(e.target.value, index)} />
                      </div>
                      <div className='flex-1 flex flex-col gap-2 justify-center items-center'>
                        {index === 0 && <label className='block text-left'>
                          {t('passenger.trip1_title')}
                        </label>}
                        <div className='h-14 flex justify-center items-center'>
                          <div className='custom-checkbox -translate-y-2'>
                            <input
                              type='checkbox'
                              checked={option.trip1}
                              onChange={handleTogglePassengerOption(index, 'trip1')}
                              id={`passenger-${index}-trip1`}
                              disabled={option.firstname === '' || isPassengerCheckboxDisabled('trip1', index)}
                            />
                            <label className='block !pl-6' htmlFor={`passenger-${index}-trip1`}>
                              {/* {`${option.firstname}${option.isUser ? ` (${t('generic.you')})` : ''}`} */}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className='flex-1 flex flex-col gap-2 justify-center items-center'>
                        {index === 0 && <label className='block text-left'>
                          {t('passenger.trip2_title')}
                        </label>}
                        <div className='h-14 flex justify-center items-center'>
                          <div className='custom-checkbox -translate-y-2'>
                            <input
                              type='checkbox'
                              checked={option.trip2}
                              onChange={handleTogglePassengerOption(index, 'trip2')}
                              id={`passenger-${index}-trip2`}
                              disabled={option.firstname === '' || isPassengerCheckboxDisabled('trip2', index)}
                            />
                            <label className='block !pl-6' htmlFor={`passenger-${index}-trip2`}>
                              {/* {`${option.firstname}${option.isUser ? ` (${t('generic.you')})` : ''}`} */}
                            </label>
                          </div>
                        </div>

                      </div>
                    </div>
                  ))}
                </div>
              </FormControl>
            </div>
            <div className='your-info-title mb-6 font-semibold'>{t('passenger.parent_info_title')}</div>
            <div className="flex flex-row gap-6">
              <div className='mb-4'>
                <label className='block mb-2 required'>
                  {t('generic.firstname')}*
                </label>
                <input type='text' className={formSubmitted && !passengerData.firstname ? '!border-red-500' : 'border'} value={passengerData.firstname} onChange={handleChange('firstname')} name='firstName' autoComplete='on'/>
              </div>
              <div className='mb-4'>
                <label className='block mb-2 required'>
                  {t('generic.lastname')}*
                </label>
                <input type='text' className={formSubmitted && !passengerData.lastname ? '!border-red-500' : 'border'} value={passengerData.lastname} onChange={handleChange('lastname')} name='lastName' autoComplete='on'/>
              </div>
            </div>
            <div className='mb-4'>
              <label className='block mb-2 required'>
                {t('generic.phone')}*
              </label>
              <div className='flex w-full'>
                <PhoneCustomInput
                  value={passengerData.phone}
                  onChange={handlePhoneChange}
                  inputClass={'!border-red-500'}
                  inputProps={{
                    className: (formSubmitted && !passengerData.phone) ? '!border-red-500' : 'border'
                  }}
                />
              </div>
            </div>
            <div className='mb-8'>
              <label className='block mb-2 required'>
                {t('generic.email')}*
              </label>
              <input type='email' className={formSubmitted && !passengerData.email ? '!border-red-500' : 'border'} value={passengerData.email} onChange={handleChange('email')} name='email' />
            </div>
         

            <div className='flex flex-row gap-6 mb-8'>
              <button onClick={onClose} className="mid light flex">
                {t('generic.cancel')}
              </button>
              <button onClick={handleSubmit} className={`flex btn-loading mid ${loading ? 'running' : ''}`}>
                <div className="loading"></div>
                {passenger ? t('generic.save') : waitlist ? t('passenger.waitlist_join') : t('passenger.confirm_button')}
              </button>
            </div>
            {/* replaced by unchecking all passengers - https://trello.com/c/MGelwZs9/12-passenger */}
            {/* {passenger && <button className='small delete' onClick={handleRemove}>
              {waitlist ? t('passenger.waitlist_remove_button') : t('passenger.remove_button')}
            </button>} */}
          </div>
        </div>
      </div>
      <div className="fixed inset-0 z-40 modal-bg" onClick={onClose}></div>
    </div>
  )
}

export default PassengerModal
